module.exports = __webpack_public_path__ + "img/2.6864f6a1.jpg";